import React, { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { LuPencilLine } from "react-icons/lu";
import SettingModel from "./SettingModel";
import { useDispatch, useSelector } from "react-redux";
import { addSetting, getAllSetting } from "../../redux/services/authSlice";
import { toast } from "react-toastify";

const Setting = () => {
  const getSettingData = useSelector((state) => state?.auth?.settingData);
  const [modelOpen, setModelOpen] = useState(false);

  const dispatch = useDispatch();

  const getAllSettingApi = useCallback(async () => {
    try {
      await dispatch(getAllSetting());
    } catch (error) {}
  }, [dispatch]);

  useEffect(() => {
    getAllSettingApi();
  }, [getAllSettingApi]);

  const columns = [
    { header: "S/N", key: "index", render: (_, __, index) => index + 1 },
    { header: "Razorpay API Key", key: "apiKey" },
    { header: "Razorpay API Secret", key: "apiSecret" },
    { header: "PhonePe API Key", key: "phonePeApiKey" },
    { header: "PhonePe API Secret", key: "phonePeApiSecret" },
    { header: "PhonePe Version", key: "phonePeVersion" },
    { header: "Multi Tab Open", key: "isMultiTabOpen" },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: () => setModelOpen(true),
    },
  ];

  const onSubmitForm = async (values, { setSubmitting }) => {
    try {
      const response = await dispatch(addSetting(values));
      if (response.payload.status === 200) {
        toast.success(response.payload.message, { autoClose: 2000 });
        getAllSettingApi();
        setModelOpen(false);
      }
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };

  const getSettingDataArr = [
    {
      apiKey: getSettingData?.apiKey,
      apiSecret: getSettingData?.apiSecret,
      phonePeApiKey: getSettingData?.phonePeApiKey,
      phonePeApiSecret: getSettingData?.phonePeApiSecret,
      phonePeVersion: getSettingData?.phonePeVersion,
      isMultiTabOpen: getSettingData?.isMultiTabOpen?.toString(),
    },
  ];

  return (
    <>
      <Table title="Setting" columns={columns} isData={true} data={getSettingDataArr} actions={actions} />

      {modelOpen && <SettingModel initialData={getSettingData} onClose={() => setModelOpen(false)} onSubmit={onSubmitForm} />}
    </>
  );
};

export default Setting;
